import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import { SITE } from "@/data/site";
import ContactForm from "@/components/ContactForm";
import Reveal from "@/components/motion/Reveal";

export default function ContactSection({ defaultService }) {
  const rows = [
    { icon: Phone, label: "Telefon", value: SITE.phoneDisplay, href: `tel:${SITE.phoneIntl}`, testid: "contact-info-phone" },
    { icon: MessageCircle, label: "WhatsApp", value: "Direkt schreiben", href: SITE.whatsapp, testid: "contact-info-whatsapp", external: true },
    { icon: Mail, label: "E-Mail", value: SITE.email, href: `mailto:${SITE.email}`, testid: "contact-info-email" },
  ];
  return (
    <section id="kontakt" className="relative bg-[#050505] py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-2">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 font-body text-[11px] font-bold uppercase tracking-[0.3em] text-volt">
              <span className="h-px w-10 bg-volt" /> Kontakt
            </p>
            <h2 className="font-heading text-4xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-6xl">
              Jetzt anfrage<span className="text-volt">n</span>
            </h2>
            <p className="mt-5 max-w-md font-body text-base text-neutral-400">
              Schnell, unkompliziert und unverbindlich. Ruf an, schreib per WhatsApp
              oder nutze das Formular – wir melden uns umgehend zurück.
            </p>

            <div className="mt-10 space-y-3">
              {rows.map((r) => (
                <a
                  key={r.label}
                  href={r.href}
                  data-testid={r.testid}
                  {...(r.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="group flex items-center gap-4 border border-white/10 bg-[#0d0d0d] p-5 transition-colors hover:border-volt"
                >
                  <span className="flex h-11 w-11 items-center justify-center border border-volt/40 text-volt">
                    <r.icon className="h-5 w-5" />
                  </span>
                  <div>
                    <p className="font-body text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-500">{r.label}</p>
                    <p className="font-heading text-xl font-bold uppercase text-white group-hover:text-volt transition-colors">{r.value}</p>
                  </div>
                </a>
              ))}
              <div className="flex items-start gap-4 border border-white/10 bg-[#0d0d0d] p-5">
                <span className="flex h-11 w-11 items-center justify-center border border-white/15 text-neutral-400">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-body text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-500">Standort</p>
                  <p className="font-body text-sm text-neutral-300">{SITE.address.street}, {SITE.address.zip} {SITE.address.city}</p>
                  <p className="mt-1 flex items-center gap-2 font-body text-xs text-volt"><Clock className="h-3.5 w-3.5" /> {SITE.hours}</p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="border border-white/10 bg-[#0a0a0a] p-7 sm:p-9">
              <h3 className="mb-6 font-heading text-2xl font-extrabold uppercase text-white">Anfrage-Formular</h3>
              <ContactForm defaultService={defaultService} />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
